import { USER } from "./user.config";
import { ITEM } from "./item.config";
import { ORDER } from "./order.config";
import { STORES } from "./store.config";
import { MASTER } from "./master.config";

const BASE_CONFIG = {
  base_url: process.env.EXPO_PUBLIC_BASE_URL,
  api_url: process.env.EXPO_PUBLIC_BASE_URL,
  s3: process.env.EXPO_PUBLIC_S3,
  digitalOcean: process.env.EXPO_PUBLIC_DIGITAL_OCEAN,
  PhonePeEnv: process.env.EXPO_PUBLIC_PHONEPE_ENV,
};

export { BASE_CONFIG, USER, ITEM, ORDER, STORES, MASTER };
